import { z } from 'zod';
import { paginationQuerySchema } from './common';
import { HEALTH, ITEM_STATUSES, PRIORITIES } from './enums';
export const createItemSchema = z.object({
    boardId: z.string().uuid(),
    title: z.string().min(1).max(300).trim(),
    description: z.string().max(10_000).trim().optional(),
    status: z.enum(ITEM_STATUSES).default('NOT_STARTED'),
    priority: z.enum(PRIORITIES).default('MEDIUM'),
    ownerId: z.string().uuid().nullable().optional(),
    startDate: z.coerce.date().nullable().optional(),
    dueDate: z.coerce.date().nullable().optional(),
    parentId: z.string().uuid().nullable().optional(),
    /** Everyone else working on this, alongside the accountable owner. */
    assigneeIds: z.array(z.string().uuid()).max(50).optional(),
});
export const updateItemSchema = createItemSchema
    .partial()
    // boardId is updatable: moving a task to another department is an edit like
    // any other. The service checks the target is one the caller can reach.
    .extend({ blockedReason: z.string().max(500).trim().nullable().optional() });
export const listItemsQuerySchema = paginationQuerySchema.extend({
    boardId: z.string().uuid().optional(),
    status: z.enum(ITEM_STATUSES).optional(),
    health: z.enum(HEALTH).optional(),
    ownerId: z.string().uuid().optional(),
    search: z.string().max(200).trim().optional(),
    dueBefore: z.coerce.date().optional(),
});
//# sourceMappingURL=item.contract.js.map